/**
 * Login page placeholder.
 *
 * The real implementation will use `supabase.auth.signInWithPassword`
 * and `supabase.auth.signInWithOAuth({ provider: 'google' })`. Forms
 * stay controlled until validation gets non-trivial.
 */

import { useTranslation } from "react-i18next";

import { Container } from "@/components/ui/Container";

export default function LoginPage() {
  const { t } = useTranslation();

  return (
    <Container className="py-16 max-w-md">
      <h1 className="text-3xl font-bold text-white">{t("auth.login.title")}</h1>
      <p className="mt-4 text-slate-400">
        {/* TODO: real Supabase auth form */}
        Placeholder — login form lands here in the next iteration.
      </p>
    </Container>
  );
}
